var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.577 15.077c0 .559.365.892.945.892h2.342c.58 0 .946-.333.946-.892V1.542c0-.559-.366-.892-.946-.892H7.522c-.58 0-.945.333-.945.892v13.535Zm5.49 0c0 .559.354.892.934.892h2.353c.569 0 .934-.333.934-.892V3.862c0-.569-.365-.902-.934-.902H13c-.58 0-.935.333-.935.902v11.215Zm-10.968 0c0 .559.354.892.945.892h2.342c.57 0 .934-.333.934-.892V6.193c0-.547-.365-.902-.934-.902H2.044c-.59 0-.945.355-.945.902v8.884Zm16.446 0c0 .559.354.892.945.892h2.342c.58 0 .945-.333.945-.892V8.45c0-.558-.365-.902-.945-.902H18.49c-.59 0-.945.344-.945.902v6.628ZM.239 18.386c0 .483.398.86.86.86h20.678c.473 0 .87-.377.87-.86a.871.871 0 0 0-.87-.86H1.1a.869.869 0 0 0-.86.86Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/poll.79addc21d7c18a9daf01ced22e977c46.svg";
export { ForwardRef as ReactComponent };